import { IOption } from "components/select/Select";
import { IResponse } from "models";

export enum ActionType {
  // get student list
  GET_STUDENT_LIST = "action/GET_STUDENT_LIST",
  GET_STUDENT_LIST_SUCCESS = "action/GET_STUDENT_LIST_SUCCESS",
  GET_STUDENT_LIST_ERROR = "action/GET_STUDENT_LIST_ERROR",
  RESET_STUDENT_LIST = "action/RESET_STUDENT_LIST",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface FilterStudentData {
  from_date: string;
  to_date: string;
  page: number;
  per_page: number;
  gernder: any;
  user_name?: string;
}

export interface GetStudentListResponse extends IResponse {
  result: GetStudentListResult;
  total_record: number;
  next_page: number;
  current_page: number;
}

export interface GetStudentListResult {
  patients: IStudentInfo[];
  filtered_patient_results: { id: number; name: string }[];
  total_patients: number;
}

export interface IStudentInfo {
  id: number;
  date_of_birth: string;
  first_name: string;
  last_name: string;
  gender: number;
  age: number;
}
